
import StripeModal from 'Core/commons/StripeModal';    

window.ExtStripe = {
    /**
	 * 
	 * @returns {undefined}@desc form init - staff only - listing payments
	 */
	prepareDirectDebitFilterForm: function(){
        console.log(arguments);
		var options = {
			success:function(data){
				ExtStripe.processDirectDebitFilterForm(data);
			}, 
			dataType:"json"
		};
		MyForm.prepare("stripe_directdebitsFilterForm", "stripe_stripeDirectdebits&action=updateListing", options);
	},
	
	processDirectDebitFilterForm: function(data){
		Listing.refresh("stripe_directdebitsListing", data, data[data.metadatasName]);
	},
	
	disconnect : function(e){
		

		if(!$(e.currentTarget).attr("locked")) {

			var options = {
				type : 'warning',
				buttons : [
					{
						text : Loc.g('Non'), 
						click : function(){
							$(this).dialog('close');
						}
					},
					{
						text : Loc.g('Oui'), 
						click : function(){
							MyFacture.post('/stripe/prefs/disconnect', {}, function(){
								Utils.reload();
							}, 'json', undefined, false);
							$(this).dialog('close');
						}
					}
				]
			}

			MyWindow.alert(Loc.g('Voulez-vous vraiment déconnecter votre compte Stripe ?'), options);

		}else {
			MyWindow.alert(Loc.g('Vous ne pouvez pas déconnecter votre compte Stripe tant que des prélèvements sont en attente'));
		}

	},

	loadDocTab : function(doctype, docid){

		if(!$('#directdebit').html()){
             
			$.post('/?_f=stripe_stripeDirectdebits', {action : 'docTab', doctype : doctype, docid : docid}, function(data){
				
				if(data.error){
					$('#directdebit').html(data.error);
				} else {
					
					$('#stripe-directdebit').html(data.tab);
					$('#stripe-directdebitListing').html(data.listing);

					Listing.init(data.prefix);
					ExtStripe.prepareDocTabFilterForm(data.listingname, docid, doctype);
                    MyFacture.initQtipDirectDebitLog();
                    
                    var formID	= 'scheduleDebitForm';
					var opts	= {
						data : {
							action	: 'recordScheduleDebitForm', 
							doctype : doctype, 
							docid	: docid
						},
						beforeSubmit : function(){
							MyFacture.startWait();
						},
						dataType : 'json',
						success : function(data){

							MyFacture.stopWait();

							if(data.status && data.status == 'error'){
								ExtStripe.handlerError(Loc.g("Le prélèvement n'a pas pu être programmé"), data.message, data.more);
							} else if(data.form && data.form.status == 'failed'){

								var msg = '';

								if(data.form.fields && data.form.fields.length > 0){
									msg = data.form.fields[0].msg;
								} else {
									msg = data.form.msg;
								}

								ExtStripe.handlerError(Loc.g("Le prélèvement n'a pas pu être programmé"), msg);

							} else {
								Utils.relocate('/?_f=' + doctype + 'Overview&id=' + docid + '&tab=stripe');
							}

						}
					};

					MyForm.prepare(formID, 'stripe_stripeDirectdebits', opts, false);
				}

			}, 'json');
			
		}

	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	prepareDocTabFilterForm: function(listingName, docid, doctype){
		
		var options = {
			success : function(data){
				ExtStripe.processDocTabFilterForm(listingName, data);
			}, 
			dataType:"json"
		};
		MyForm.prepare(listingName + "FilterForm", "stripe_stripeDirectdebits&action=updateTabDirectDebitListing&docid="+docid+"&doctype="+doctype, options);
	},

	/**
	 * 
	 * @param {type} data
	 * @returns {undefined}
	 */
	processDocTabFilterForm: function(listingName, data){
		Listing.refresh(listingName + "Listing", data, data[data.metadatasName]);
	},
	
	/**
	* 
	* @param {type} error
	* @param {type} more
	* @returns {undefined}
	*/
   handlerError : function(message, error, more){
	   
	   var errorMsg = message;
	   
	   if(error){
		   errorMsg += ' : ' + error;
	   }
	   
	   if(more){
		   errorMsg += '<br><br>';
		   errorMsg += '<b>' + Loc.g("Plus d'informations") + ' : </b>'+ more;
	   }
	   
	   MyWindow.alert(errorMsg, {type : 'error'});
   },
   
   /**
    * 
    * @param {type} directdebitId
    * @return {undefined}
    */
   retryDirectdebit : function(directdebitId){
       
       
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Non'), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g('Oui'), 
					'class' : 'btn btn-primary',
					click : function(){
						MyFacture.post('stripe_stripeDirectdebits', {action : 'retry', directDebitId : directdebitId}, function(data){
							
							if(data.status && data.status == 'error'){
								ExtStripe.handlerError(Loc.g("Le paiement ne peut être réitéré"), data.message, data.more);
							} else {
								Utils.reload();
							}
							
						}, 'json');
						$(this).dialog('close');
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g('Voulez-vous vraiment réiterer ce prélèvement ?'), options);
       
   },
   
   /**
    * 
    * @param {type} directdebitId
    * @return {undefined}
    */
    cancelDirectdebit : function(directdebitId){

        var options = {
            type : 'warning',
            buttons : [
                {
                    text : Loc.g('Non'), 
                    'class' : 'btn btn-default',
                    click : function(){
                        $(this).dialog('close');
                    }
                },
                {
                    text : Loc.g('Oui'), 
                    'class' : 'btn btn-primary',
                    click : function(){
                        MyFacture.post('stripe_stripeDirectdebits', {action : 'cancel', directDebitId : directdebitId}, function(data){

                            if(data.status && data.status == 'error'){
                                ExtStripe.handlerError(Loc.g("Le prélèvement n'a pas pu être annulé"), data.message, data.more);
                            } else {
                                Utils.reload();
                            }

                        }, 'json');
                        $(this).dialog('close');
                    }
                }

            ]
        };

        MyWindow.alert(Loc.g('Voulez-vous vraiment annuler ce prélèvement ?'), options);

	  },
	  
	  cancelMassDirectdebit : function(rowSelection) {
		var msg = Loc.g("L'ensemble des prélèvements sélectionnés dont le status est en attente seront annulés.");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Annuler les prélèvements"),
			buttons: [
                {
                    text: Loc.g("Fermer"),
					'class' : 'btn btn-default',
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
					text: Loc.g("Valider"),
					'class' : 'btn btn-primary',
					click: function () {

						MyWindow.wait('alertWindow');
						MyFacture.post('stripe_stripeDirectdebits', {action: "massCancelled", ids : rowSelection}, function (data) {
							
							MyWindow.close('_all');

							if(data.status === "success")  {

								if(data.paymentCancelled && data.paymentCancelled.length > 0){
									var recap = Loc.g("Les prélèvements ont bien été annulés");
									Push.success(recap);
								} else {
									var recap = Loc.g("Aucun prélèvement n'a été annulé");
									Push.warning(recap)
								}

							} else {
								Push.error(Loc.g("Une erreur est survenue !"));
							}

							Listing.update('stripe_directdebitsListing')

						}, "json");
					}
				}
			]
		};

		MyWindow.alert(msg, options);
		
      },
      
    prepareCustomerSaving :function(thirdid, corpid, domSelectorWrapper, callbackUrl, labelButton){
        
        MyFacture.post("/rest/stripe/card/button", {
            thirdid     : thirdid,
            corpid      : corpid,
            callbackUrl : callbackUrl,
            labelButton : labelButton
        },function(response){

            if(labelButton){
                response.data.label = labelButton;
            }

            new StripeModal(response.data, domSelectorWrapper);
        },"json", undefined, false);
    }
	
};